import { apiClient } from "./client";

const GetAll = () => {
  return apiClient
    .get("/Reservation");
}

const GetByKey = (id) => {
  return apiClient
    .get("/Reservation/GetById", {
      params: {
        'id': id
      }
    });
}

const Filter = (cityConsistency, brokerGroupId) => {
  return apiClient
    .post("/Reservation/Filter", {
      "cityConsistency": cityConsistency,
      "brokerGroupId": brokerGroupId
    });
}


const ReservationDropDown = () => {
  return apiClient
    .get("/Reservation/ReservationDropDown");
}

const GetForUser = () => {
  return apiClient
    .get("/Reservation/GetForUser");
}
const GetDispatchOfTheDayDropDown = () => {
  return apiClient
    .get("/Reservation/GetDispatchOfTheDayDropDown");
}



const SoftDelete = (id) => {
  return apiClient
    .delete("/Reservation/SoftDelete", {
      params: {
        'Id': id
      }
    });
}

const Add = (data) => {
  return apiClient.post('/Reservation', {
    "planID": data.planID,
    "dispatchOfTheDay": data.dispatchOfTheDay,
    "firstDescription": data.firstDescription,
    "secondDescription": data.secondDescription,
    "thirdDescription": data.thirdDescription,
    "brokerGroupId": data.brokerGroupId,
    "capacity": data.capacity
  }
  )
}

const Update = (data) => {
  return apiClient.put('/Reservation', {
    "planID": data.planID,
    "isActive": data.isActive,
    "firstDescription": data.firstDescription,
    "secondDescription": data.secondDescription,
    "thirdDescription": data.thirdDescription,
    "dispatchOfTheDay": data.dispatchOfTheDay,
    "brokerGroupId": data.brokerGroupId,
    "capacity": data.capacity
  }, {
    params: {
      'Id': data.id
    }
  }
  )
}
const UpdateInitialReservation = (data) => {
  return apiClient.put('/Reservation/UpdateInitialReservation', {
    "planID": data.planID,
    "dispatchOfTheDay": data.dispatchOfTheDay,
    "firstDescription": data.firstDescription,
    "secondDescription": data.secondDescription,
    "thirdDescription": data.thirdDescription,
    "brokerGroupId": data.brokerGroupId,
    "requestedForCity": data.requestedForCity,
    "capacity": data.capacity
  }
  )
}

const UpdatePlanToLast = (reservationIdArr) => {
  return apiClient.put('/Reservation/UpdatePlanToLast', reservationIdArr)
}

const FilterReserve = (data) => {
  return apiClient.post('/Reservation/FilterReserve',
    {
      "hotelId": data.hotelId,
      "planCode": data.planCode,
      "cityConsistency": data.cityConsistency,
      "flightDate": data.flightDate,
      "inputDto": {
        "filters": data.filters,
        "orderBy": data.orderBy,
        "orderDescending": data.orderDescending,
        "pageNumber": data.pageNumber,
        "pageSize": data.pageSize
      }
    }
  );
}

const ActiveCurrentReservation = (data) => {
  return apiClient.post('/Reservation/ActiveCurrentReservation',
    {
      "fromDate": data.fromDate,
      "toDate": data.toDate,
      "dispatchOfTheDay": data.dispatchOfTheDay,
      "planCode": data.planCode,
      "hotelId": data.hotelId
    }
  );
}

const DeActiveReserve = (id) => {
  return apiClient.put('/Reservation/DeActiveReserve', {
  }, {
    params: {
      'Id': id
    }
  }
  )
}

const GetBrokerGroupInfoByGroupId = (brokerGroupId) => {
  return apiClient
    .get("/Reservation/GetBrokerGroupInfoByGroupId", {
      params: {
        'brokerGroupId': brokerGroupId
      }
    });
}

const GetReservationForUpdatePlan = (data) => {
  return apiClient.post('/Reservation/GetReservationForUpdatePlan',
    {
      "planCode": data.planCode,
      "date": data.date,
      "hotelStructureId": data.hotelStructureId
    }
  );
}

const reservationApi = {
  Add, Update, GetAll, GetByKey, ReservationDropDown, GetForUser,
  GetDispatchOfTheDayDropDown, SoftDelete, Filter, FilterReserve, UpdateInitialReservation,
  ActiveCurrentReservation, DeActiveReserve, UpdatePlanToLast, GetBrokerGroupInfoByGroupId, GetReservationForUpdatePlan
}
export default reservationApi;